import { render, staticRenderFns } from "./LastNewsList.vue?vue&type=template&id=a1a75ace&scoped=true"
import script from "./LastNewsList.vue?vue&type=script&lang=js"
export * from "./LastNewsList.vue?vue&type=script&lang=js"
import style0 from "./LastNewsList.vue?vue&type=style&index=0&id=a1a75ace&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a75ace",
  null
  
)

export default component.exports